module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module container_lg moduleThree"
  }, [_c('div', {
    staticClass: "scene"
  }, [_c('library-back-drop'), _vm._v(" "), _c('div', {
    staticClass: "layer"
  }, [_c('schoolHallwaySecond')], 1), _vm._v(" "), _c('div', {
    staticClass: "layer"
  }, [_c('second-empty-back-drop')], 1), _vm._v(" "), _c('div', {
    staticClass: "layer"
  }, [_c('hailey', {
    attrs: {
      "data": _vm.haileyData
    }
  }), _vm._v(" "), _c('reece', {
    attrs: {
      "data": _vm.reeceData
    }
  }), _vm._v(" "), _c('devyn', {
    attrs: {
      "data": _vm.devynData
    }
  }), _vm._v(" "), _c('aye', {
    attrs: {
      "data": _vm.ayeData
    }
  }), _vm._v(" "), _c('ria', {
    attrs: {
      "data": _vm.riaData
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "layer"
  }, [_c('library-doors', {
    attrs: {
      "data": _vm.libraryDoorsData,
      "showOnEdge": _vm.showDoorsOnEdge
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "layer layer-full index-2",
    class: _vm.modalLayerClass
  }, [_c('modal', {
    attrs: {
      "active": _vm.modalActive,
      "text": _vm.modalText,
      "ind": _vm.modalInd,
      "modalStyle": _vm.modalStyle
    },
    on: {
      "close": _vm.closeModalLayer
    }
  })], 1), _vm._v(" "), _c('control-panel', {
    attrs: {
      "text": _vm.activeText,
      "control_panel_active": _vm.controlPanelActive
    },
    on: {
      "textProgress": _vm.updateScene
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-519539e0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/module_3/module_3.vue
// module id = 770
// module chunks = 1